import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M0 4.5A4.5 4.5 0 014.5 0h15A4.5 4.5 0 0124 4.5v15a4.5 4.5 0 01-4.5 4.5h-15A4.5 4.5 0 010 19.5v-15z" fill="#33658A" /><path d="M3.75 6v12h3v-4.5h3.75v-2.25H6.75V9h4.8l1.57 2.63L9.75 18h3L15 14.25 17.25 18h3l-3.38-6.38L20.25 6h-3.38L15 9l-1.88-3H3.76z" fill="#fff" /></svg>);